// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2025-12-11T11:32:34+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  190785
//    Project:        617
//    Environment:    7626 - master
//    MD5:            fa013d1fb1c796f27c6d200a192d0a96
//    Signature:      eyJpdiI6IjRcL253dXBjOWpXeWR6dUZnN0JaUDVBPT0iLCJ2YWx1ZSI6InBoOE5tVndZYTBWb0h1YWdHdE1Cd3pjYzB1a1I1cjU0NVQxTk5DdThQdGNXS3RuQjBrK2JRWHZGSUg0VklzUFwvTERFMU5pM2lPOU45cjk0WXBwYk5XeUNwdmpLNm1XejVuYWdFczRTUGd6UjgydmZzMmwzK3Y4SWxqQXUrSGMyblo1a2xWaDdcL2VMXC9WTHFkNEFxb3NvYitCSVZRUjVmOU5SQXhnWjVQRGFCXC9UME9XUGhDTnRrM3k2UFZcLzlmRTlLelNBVklHUmQydkF2WmFFZzBxMmNvSkdPakhYb05NZ2FWb1R2TDdRSWJKdWs5ZmJRQ2pDMDNxdmgxb01jWW1maERIY2R0SThZZmVQeUYxYXdHa1lXOG5EU3ZJR3kzaUxJQ3Fiem9EeTlxSGlIK3pHQVY4TnZrSTBsWWs4SjZIM1VqTHJRUXV6NEtlZFhoOWMxV2JBZ2szODRxZkNCdWN4Zk5XZDlJXC8yMmU1ZDV1MVwvYk5RZDFNdVU0TkNTOFNEWGtUSVFTV1NSWVNmREVlTGxcL2t3S0hXdz09IiwibWFjIjoiZWU2ZDA3YTk4ZjE2M2EwMmVjMjY0ODA4NmE1OTM1N2E3MGJiYzE2OTI0OWRlMTJjOTg3YWNlYjQxMjhhNzNkMSJ9
if (!customElements.get('show-more-button')) {
  customElements.define(
    'show-more-button',
    class ShowMoreButton extends HTMLElement {
      constructor() {
        super();
        const button = this.querySelector('button');
        button.addEventListener('click', (event) => {
          this.expandShowMore(event);
          const nextElementToFocus = event.target.closest('.parent-display').querySelector('.show-more-item');
          if (nextElementToFocus && !nextElementToFocus.classList.contains('hidden') && nextElementToFocus.querySelector('input')) {
            nextElementToFocus.querySelector('input').focus();
          }
        });
      }
      expandShowMore(event) {
        const parentDisplay = event.target.closest('[id^="Show-More-"]').closest('.parent-display');
        const parentWrap = parentDisplay.querySelector('.parent-wrap');
        this.querySelectorAll('.label-text').forEach((element) => element.classList.toggle('hidden'));
        parentDisplay.querySelectorAll('.show-more-item').forEach((item) => item.classList.toggle('hidden'));
        if (!this.querySelector('.label-show-less')) {
          this.classList.add('hidden');
        }
      }
    }
  );
}
